<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex sm4>
            <v-text-field
              name="code"
              label="Code"
              type="text"
              v-model="queryParams.code"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              name="name"
              label="Name"
              type="text"
              v-model="queryParams.name"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex sm12 class="mt-1">
          <v-card>
            <v-data-table
              v-model="selectedManufacturingCostList"
              :headers="headers"
              :items="manufacturingCostList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <!--<template slot="headers" slot-scope="props">
                <tr>
                  <th></th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>-->
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedManufacturingCostList"
                    multiple
                    :disabled="
                      !!selectedList &&
                      !!selectedList.find((v) => v.id == props.item.id)
                    "
                  ></v-checkbox>
                </td>
                <td>{{ props.item.code }}</td>
                <td>{{ props.item.name }}</td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds
                      | format-ms-date-time
                  }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  <v-icon
                    medium
                    color="green"
                    v-if="props.item.status == 'ACTIVE'"
                    >check_circle</v-icon
                  >
                  <v-icon medium color="red" v-else>cancel</v-icon>
                </td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="dialogClose">Ok</v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { manufacturingCostService } from "../../services/manufacturing-cost-service";
import { commonService } from "../../services/common-service";

export default {
  name: "MultiSelectManufacturingCostDialog",
  props: {
    showDialog: Boolean,
    params: Object,
    selectedList: Array,
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      code: "",
      name: "",
      status: "ACTIVE",
    },
    headers: [
      { text: "", sortable: false },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "name" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    manufacturingCostList: [],
    selectedManufacturingCostList: [],
  }),
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getManufacturingCostList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = { ...this.params };
          this.manufacturingCostList = [];
          this.selectedManufacturingCostList = [];
          this.getManufacturingCostList();
        }
      },
    },
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getManufacturingCostList();
    },
    getManufacturingCostList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      manufacturingCostService
        .getManufacturingCostList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.manufacturingCostList = res.data.manufacturingCostList;
            this.totalRows = res.data.totalElements;
            this.checkSelected();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    dialogClose() {
      let newMfgCostList = [];
      this.selectedManufacturingCostList.forEach((v) => {
        let newCost = commonService.search("id", v.id, this.selectedList);
        if (typeof newCost == "undefined") {
          newMfgCostList.push(v);
        }
      });
      this.$emit("close", newMfgCostList);
    },
    checkSelected() {
      if (this.selectedList.length > 0) {
        this.selectedManufacturingCostList = [];
        this.selectedList.forEach((mfgCost) => {
          this.selectedManufacturingCostList.push(
            commonService.search("id", mfgCost.id, this.manufacturingCostList)
          );
        });
      } else {
        this.selectedManufacturingCostList = [];
      }
    },
  },
};
</script>
